export const STORE_USER_NAME = 'user';

export const GETTER_USER_PERMISSIONS = 'userPermissions';

export const STATE_TOKEN = 'token';
export const STATE_VERSION_INFO = 'versionInfo';
export const STATE_PROFILE = 'profile';
export const STATE_PENDING = 'pending';
export const STATE_USER_PERMISSONS = 'userPermissions';

export const MUTATION_SET_LOGIN_DATA = 'setLoginData';
export const MUTATION_DESTROY_SESSION = 'destroySession';
export const MUTATION_LOGIN_PENDING = 'loginPending';
export const MUTATION_LOGIN_ERROR = 'loginError';
export const MUTATION_SET_USER_PERMISSIONS = 'setUserPermissions';

export const ACTION_API_LOGIN = 'apiLogin';
export const ACTION_REPORT_LOGIN_ERROR = 'reportLoginError';
export const ACTION_LOGOUT = 'logout';
export const ACTION_GET_USER_PERMISSIONS = 'getUserPermissions';
